/* OS EDD - Sticky Timer (scoped, no globals) */
(() => {
  const ROOT_SEL = '[data-os-edd-timer]';

  function pad2(n) {
    const v = Math.max(0, Math.floor(Number(n) || 0));
    return String(v).padStart(2, '0');
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = txt;
  }

  function initFlowers(root) {
    const flowersWrap = root.querySelector('[data-osedd-flowers]');

    if (!flowersWrap || flowersWrap.hasChildNodes()) return;

    const iconStyle =
      flowersWrap.getAttribute('data-osedd-icon-style') || 'flowers';
    const customEmojis = (flowersWrap.getAttribute('data-osedd-emojis') || '')
      .split(/[,\n]+/)
      .map((emoji) => emoji.trim())
      .filter(Boolean);
    const imageUrls = [1, 2, 3, 4]
      .map((slot) => (flowersWrap.getAttribute(`data-osedd-image-${slot}`) || '').trim())
      .filter(Boolean);
    const isMobileFlowers = window.matchMedia('(max-width: 640px)').matches;
    const flowerCount = isMobileFlowers ? 16 : 28;
    const flowerColors = [
      'is-pink',
      'is-yellow',
      'is-purple',
      'is-blue',
      'is-mint',
      'is-orange',
    ];

    if (
      (iconStyle === 'custom_emojis' && !customEmojis.length) ||
      (iconStyle === 'custom_images' && !imageUrls.length) ||
      (iconStyle === 'custom_mix' && !customEmojis.length && !imageUrls.length)
    ) return;

    for (let flowerIndex = 0; flowerIndex < flowerCount; flowerIndex += 1) {
      const flower = document.createElement('span');
      const useLeftSide = flowerIndex % 2 === 0;
      const flowerLeft = useLeftSide
        ? Math.random() * 30
        : 70 + Math.random() * 30;

      let iconType = 'flower';

      if (iconStyle === 'pumpkins') {
        iconType = 'pumpkin';
      } else if (iconStyle === 'ghosts') {
        iconType = 'ghost';
      } else if (iconStyle === 'halloween') {
        iconType = flowerIndex % 4 < 2 ? 'pumpkin' : 'ghost';
      } else if (iconStyle === 'custom_emojis') {
        iconType = 'emoji';
      } else if (iconStyle === 'custom_images') {
        iconType = 'image';
      } else if (iconStyle === 'custom_mix') {
        iconType = customEmojis.length && (!imageUrls.length || flowerIndex % 2 === 0)
          ? 'emoji'
          : 'image';
      }

      const flowerSize = iconType === 'flower'
        ? (isMobileFlowers ? 9 + Math.random() * 7 : 11 + Math.random() * 10)
        : (isMobileFlowers ? 16 + Math.random() * 8 : 18 + Math.random() * 10);
      const flowerDrift = -18 + Math.random() * 36;
      const flowerRotation = iconType === 'flower'
        ? (Math.random() > 0.5 ? 360 : -360)
        : -20 + Math.random() * 40;

      flower.className = iconType === 'flower'
        ? `osedd-timer__flower ${flowerColors[flowerIndex % flowerColors.length]}`
        : `osedd-timer__flower is-${iconType}`;

      const contentIndex = iconStyle === 'custom_mix'
        && customEmojis.length
        && imageUrls.length
        ? Math.floor(flowerIndex / 2)
        : flowerIndex;

      if (iconType === 'pumpkin' || iconType === 'ghost') {
        flower.textContent = iconType === 'pumpkin' ? '🎃' : '👻';
      } else if (iconType === 'emoji') {
        flower.textContent = customEmojis[contentIndex % customEmojis.length];
      } else if (iconType === 'image') {
        const image = document.createElement('img');
        image.src = imageUrls[contentIndex % imageUrls.length];
        image.alt = '';
        image.decoding = 'async';
        flower.appendChild(image);
      }

      flower.style.left = `${flowerLeft.toFixed(2)}%`;

      flower.style.setProperty(
        '--osedd-flower-size',
        `${flowerSize.toFixed(2)}px`
      );

      flower.style.setProperty(
        '--osedd-flower-duration',
        `${(4.5 + Math.random() * 4).toFixed(2)}s`
      );

      flower.style.setProperty(
        '--osedd-flower-delay',
        `${(-Math.random() * 9).toFixed(2)}s`
      );

      flower.style.setProperty(
        '--osedd-flower-drift-x',
        `${flowerDrift.toFixed(2)}px`
      );

      flower.style.setProperty(
        '--osedd-flower-rotation',
        `${flowerRotation}deg`
      );

      flower.style.setProperty(
        '--osedd-flower-static-top',
        `${(12 + Math.random() * 76).toFixed(2)}%`
      );

      flower.style.setProperty(
        '--osedd-flower-static-rotation',
        `${(-30 + Math.random() * 60).toFixed(2)}deg`
      );

      flowersWrap.appendChild(flower);
    }
  }

  function getEndMs(root) {
    const key = (root.getAttribute('data-osedd-storage-key') || '').trim();
    const durMins = Number(
      root.getAttribute('data-osedd-duration-minutes') || 0
    );

    // Default fallback: 2h 30m
    const durationMinutes = durMins > 0 ? durMins : 150;
    const now = Date.now();

    if (key) {
      const stored = Number(window.localStorage.getItem(key) || 0);

      if (stored && stored > now) return stored;

      const end = now + durationMinutes * 60 * 1000;

      window.localStorage.setItem(key, String(end));

      return end;
    }

    // No key means the timer resets on each load.
    return now + durationMinutes * 60 * 1000;
  }

  function applyBodyOffset(root) {
    // Prevent the fixed bar from covering page content.
    const bar = root.querySelector('.osedd-timer__bar');

    if (!bar) return;

    const h = Math.ceil(bar.getBoundingClientRect().height || 0);

    if (!h) return;

    // Save previous inline padding so it can be restored if needed.
    if (!root.__oseddPrevBodyPad) {
      root.__oseddPrevBodyPad = document.body.style.paddingTop || '';
    }

    document.body.style.paddingTop = `${h}px`;
  }

  function tick(root) {
    const endMs = root.__oseddEndMs;
    const hideExpired =
      root.getAttribute('data-osedd-hide-expired') === '1';
    const expiredText = (
      root.getAttribute('data-osedd-expired-text') || ''
    ).trim();

    const elH = root.querySelector('[data-osedd-hours]');
    const elM = root.querySelector('[data-osedd-mins]');
    const elS = root.querySelector('[data-osedd-secs]');

    if (!endMs) {
      setText(elH, '00');
      setText(elM, '00');
      setText(elS, '00');

      return;
    }

    const now = Date.now();
    const diff = endMs - now;

    if (diff <= 0) {
      setText(elH, '00');
      setText(elM, '00');
      setText(elS, '00');

      if (hideExpired) {
        root.style.display = 'none';

        if (root.__oseddPrevBodyPad !== undefined) {
          document.body.style.paddingTop = root.__oseddPrevBodyPad;
        }
      } else if (expiredText) {
        const msg = root.querySelector('.osedd-timer__msg');

        if (msg) {
          msg.textContent = expiredText;
        }
      }

      return;
    }

    const totalSec = Math.floor(diff / 1000);
    const hrs = Math.floor(totalSec / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;

    setText(elH, hrs < 100 ? pad2(hrs) : String(hrs));
    setText(elM, pad2(mins));
    setText(elS, pad2(secs));
  }

  function bind(root) {
    if (!root || root.__oseddBound) return;

    root.__oseddBound = true;
    root.__oseddEndMs = getEndMs(root);

    initFlowers(root);

    // Initial render and offset.
    tick(root);
    applyBodyOffset(root);

    // Keep offset correct on resize and orientation changes.
    root.__oseddOnResize = () => applyBodyOffset(root);
    window.addEventListener('resize', root.__oseddOnResize);

    // 250ms interval keeps it feeling live.
    root.__oseddInt = window.setInterval(() => tick(root), 250);
  }

  function init() {
    document.querySelectorAll(ROOT_SEL).forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();